import React, { useEffect, useState } from "react";
import {
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton,
  Switch
} from "@mui/material";
import { Add, Edit, Delete } from "@mui/icons-material";
import api from "../services/api";

export default function Usuarios() {
  const [usuarios, setUsuarios] = useState([]);
  const [open, setOpen] = useState(false);
  const [editando, setEditando] = useState(false);

  const [usuarioAtual, setUsuarioAtual] = useState({
    id: 0,
    nome: "",
    login: "",
    senha: "",
    ativo: true,
    administrador: false,
    codigoVendedor: null
  });

  // =============================
  // CARREGAR LISTA
  // =============================
  const carregarUsuarios = async () => {
    try {
      const resp = await api.get("/usuarios");
      const dados = Array.isArray(resp.data) ? resp.data : [];
      setUsuarios(dados);
    } catch (err) {
      console.error("Erro ao carregar usuários:", err);
      alert("Erro ao carregar usuários");
      setUsuarios([]);
    }
  };

  useEffect(() => {
    carregarUsuarios();
  }, []);

  // =============================
  // ABRIR MODAL
  // =============================
  const abrirModal = (usuario = null) => {
    if (usuario) {
      setUsuarioAtual({
        id: usuario.id,
        nome: usuario.nome,
        login: usuario.login,
        senha: usuario.senha,
        ativo: usuario.ativo,
        administrador: usuario.administrador === true || usuario.administrador === "S",
        codigoVendedor: usuario.codigoVendedor
      });
      setEditando(true);
    } else {
      setUsuarioAtual({
        id: 0,
        nome: "",
        login: "",
        senha: "",
        ativo: true,
        administrador: false,
        codigoVendedor: ""
      });
      setEditando(false);
    }

    setOpen(true);
  };

  // =============================
  // SALVAR
  // =============================
  const salvarUsuario = async () => {
    try {
      const dados = {
        ...usuarioAtual,
        administrador: usuarioAtual.administrador,
        codigoVendedor: usuarioAtual.codigoVendedor
          ? Number(usuarioAtual.codigoVendedor)
          : null
      };

      if (editando) {
        await api.put(`/usuarios/${usuarioAtual.id}`, dados);
      } else {
        await api.post("/usuarios", dados);
      }

      setOpen(false);
      carregarUsuarios();
    } catch (err) {
      console.log(err);
      alert("Erro ao salvar usuário");
    }
  };

  // =============================
  // EXCLUIR
  // =============================
  const excluirUsuario = async (id) => {
    if (!window.confirm("Deseja realmente excluir?")) return;

    try {
      await api.delete(`/usuarios/${id}`);
      carregarUsuarios();
    } catch (err) {
      console.error("Erro ao excluir:", err);
      alert("Erro ao excluir");
    }
  };

  return (
    <>
      <Typography variant="h4" gutterBottom>
        Usuários do Sistema
      </Typography>

      <Button
        variant="contained"
        startIcon={<Add />}
        onClick={() => abrirModal()}
        sx={{ mb: 2 }}
      >
        Novo Usuário
      </Button>

      {/* LISTA */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Nome</TableCell>
              <TableCell>Login</TableCell>
              <TableCell>Administrador</TableCell>
              <TableCell>Cód. Vendedor</TableCell>
              <TableCell>Ativo</TableCell>
              <TableCell align="right">Ações</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {usuarios.map((u) => (
              <TableRow key={u.id}>
                <TableCell>{u.id}</TableCell>
                <TableCell>{u.nome}</TableCell>
                <TableCell>{u.login}</TableCell>
                <TableCell>{u.administrador ? "Sim" : "Não"}</TableCell>
                <TableCell>{u.codigoVendedor ?? "-"}</TableCell>
                <TableCell>
                  <Switch checked={u.ativo} disabled />
                </TableCell>

                <TableCell align="right">
                  <IconButton color="primary" onClick={() => abrirModal(u)}>
                    <Edit />
                  </IconButton>

                  <IconButton color="error" onClick={() => excluirUsuario(u.id)}>
                    <Delete />
                  </IconButton>
                </TableCell>

              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* MODAL */}
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>{editando ? "Editar Usuário" : "Novo Usuário"}</DialogTitle>

        <DialogContent>
          <TextField
            margin="dense"
            label="Nome"
            fullWidth
            value={usuarioAtual.nome}
            onChange={(e) =>
              setUsuarioAtual({ ...usuarioAtual, nome: e.target.value })
            }
          />

          <TextField
            margin="dense"
            label="Login"
            fullWidth
            value={usuarioAtual.login}
            onChange={(e) =>
              setUsuarioAtual({ ...usuarioAtual, login: e.target.value })
            }
          />

          <TextField
            margin="dense"
            label="Senha"
            type="password"
            fullWidth
            value={usuarioAtual.senha}
            onChange={(e) =>
              setUsuarioAtual({ ...usuarioAtual, senha: e.target.value })
            }
          />

                    {/* CÓDIGO DO VENDEDOR */}
          <TextField
            margin="dense"
            label="Código do Vendedor"
            fullWidth
            type="number"
            value={usuarioAtual.codigoVendedor || ""}
            onChange={(e) =>
              setUsuarioAtual({
                ...usuarioAtual,
                codigoVendedor: e.target.value,
              })
            }
          />

{/* ADMIN */}
          <Typography sx={{ mt: 2 }}>Administrador</Typography>
          <Switch
            checked={usuarioAtual.administrador}
            onChange={(e) =>
              setUsuarioAtual({
                ...usuarioAtual,
                administrador: e.target.checked,
              })
            }
          />
          
          {/* ATIVO */}
          <Typography sx={{ mt: 2 }}>Usuário Ativo</Typography>
          <Switch
            checked={usuarioAtual.ativo}
            onChange={(e) =>
              setUsuarioAtual({ ...usuarioAtual, ativo: e.target.checked })
            }
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancelar</Button>
          <Button variant="contained" onClick={salvarUsuario}>
            Salvar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
